<template>

    <div :class="editing ? 'tagbox opened' : 'tagbox closed'">

        <div class="max-w-full text-sm">

            <dropdown-tags align="center" width="60" :contentClasses="['pb-2', 'bg-white', '-mt-1']" @click.prevent.stop
                @onShow="onShow()" @onHide="onHide()" ref="dropdown">

                <template #trigger>
                    <div class="tagsContainer flex flex-row flex-wrap text-sm"
                        v-bind:class="{ 'has_tags': video.tags.length > 0, 'empty': video.tags.length == 0 }"
                        @click="clickTagBox" ref="tagBox">
                        <div v-if="video.tags.length == 0" class="relative flex flex-grow">
                            <div class="notag text-gray-400">no tag</div>
                            <div class="addtag text-gray-600 bg-gray-100 rounded">
                                <vue-feather type="plus" class="h-4 w-4 align-middle text-xs"></vue-feather> add tag…
                            </div>
                        </div>
                        <div v-else class="tag px-2 mb-2 py-1 rounded text-gray-700 text-xs mr-2 flex flex-row"
                            v-for="tag in video.tags" :key="'tag_' + tag.id" :style="'background-color:' + tag.color"
                            v-bind:class="{ 'px-3': !editing, 'mr-3': !editing }">
                            <div class="name">{{ tag.name }}</div>
                            <!-- <transition name="fade"> -->
                            <div class="ml-1 -mr-1 text-gray-600 hover:text-gray-900 cursor-pointer flex items-center"
                                @click.stop="detachTag(tag, $event)" v-show="editing">
                                <vue-feather type="x" class="h-3 w-3 align-middle"></vue-feather>
                            </div>
                            <!-- </transition> -->
                        </div>

                    </div>
                </template>

                <template #content>
                    <div class="tagsMenu" :key="'tagsMenu_key_' + refresh">

                        <input
                            class="blank border-0 border-b-2 border-gray-200 focus:border-gray-200 text-sm bg-bottom-1 focus:border-0 bg-white focus:ring-0 px-3 pt-4 w-full sticky top-0 z-10"
                            ref="newTag" placeholder="type tag…" type="text" v-model="typing"
                            @keyup.enter="enterNewTag()" @keyup="filter()" @click.prevent.stop />

                        <p class="text-gray-600 mx-3 mt-3">Select a tag or create one</p>

                        <div class="relative mt-2 hover:bg-gray-100" v-for="tag in filtered_tags"
                            :key="'list_tag_' + tag.id" @click.stop>

                            <div class="flex flex-row justify-between"
                                v-bind:class="{ 'editing': tag.id == tagEditId, 'bg-gray-100': tag.id == tagEditId }"
                                @click.stop="attachTag(tag, $event)">

                                <div v-if="tag.id == tagEditId" class="tagEdit flex flex-col flex-grow">

                                    <div class="flex flex-row">

                                        <div class="flex flex-col justify-center ml-3 cursor-pointer rounded hover:bg-gray-200 py-1 px-1 my-1"
                                            title="delete" @click.stop="deleteTag(tag, $event)">
                                            <vue-feather type="trash" class="h-4 w-4 align-middle "> </vue-feather>
                                        </div>

                                        <div class="type flex-grow">
                                            <input class="form-control editTag focus:ring-0 mt-1"
                                                :id="'input_tag_id_' + tag.id" placeholder="tag name…" type="text"
                                                v-model="tag.name" @blur="blurInput(tag, $event)" />
                                        </div>
                                        <div class="flex flex-col justify-center cursor-pointer rounded hover:bg-gray-200 py-1 px-1 my-1 mr-3"
                                            title="close" @click.stop="cancelEdit(tag, $event)">
                                            <vue-feather type="x" class="h-4 w-4 align-middle"> </vue-feather>
                                        </div>
                                    </div>

                                    <div class="colors flex flex-row">
                                        <ul class="tag_colorpicker my-4 px-3 flex-grow flex flex-row justify-between">
                                            <li class="flex " v-for="color in colors" :title="color.name"
                                                :key="'color_' + color.color" @click="changeColor(color, tag, $event)"
                                                :style="styleColor(color, tag)"></li>
                                        </ul>
                                    </div>
                                </div>



                                <div v-else class="px-2 my-1 py-1 rounded text-gray-700 text-xs ml-3 cursor-pointer"
                                    :style="'background-color:' + tag.color">
                                    <div class="name">{{ tag.name }}</div>
                                </div>

                                <div v-if="tag.id != tagEditId"
                                    class="flex flex-col justify-center mr-3 cursor-pointer rounded hover:bg-gray-200 px-1 my-1"
                                    title="edit" @click.prevent.stop="editTag(tag, $event)">
                                    <vue-feather type="more-horizontal" class="h-4 w-4 align-middle">
                                    </vue-feather>
                                </div>

                            </div>

                            <transition name="fade">
                                <div class="text-white font-bold bg-red-600 absolute top-0 w-full h-full flex flex-grow flex-col"
                                    v-if="tag.id == tagDeleteConfirm">
                                    <div class="pt-2 text-center">Clear this tag?<br /><small>(can’t be undone)</small>
                                    </div>
                                    <div>
                                        <div class="pt-1 flex flex-row justify-center">
                                            <button type="button"
                                                class="inline-flex items-center px-4 py-1 border border-transparent rounded-md bg-white bg-opacity-20 hover:bg-opacity-30 text-xs text-white tracking-widest focus:outline-none focus:border-0 focus:ring focus:ring-0 disabled:opacity-25 transition"
                                                @click.prevent="confirmDelete(tag, $event)">
                                                Confirm
                                            </button>
                                            <button type="button"
                                                class="ml-5 inline-flex items-center px-4 py-1 border border-transparent rounded-md font-bold bg-white bg-opacity-20 hover:bg-opacity-30 text-xs text-white tracking-widest focus:outline-none focus:border-0 focus:ring focus:ring-0 disabled:opacity-25 transition"
                                                @click.prevent="cancelDelete(tag, $event)">
                                                Cancel <vue-feather type="x"
                                                    class="ml-2 h-4 w-4 align-middle"></vue-feather>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </transition>


                        </div>

                        <transition name="fade">
                            <div v-if="typing != '' && !slugFound" @click="clickCreateTag($event)"
                                class="flex flex-row cursor-pointer hover:bg-gray-100 py-1 px-3">
                                <div class="flex flex-row flex-grow" style="overflow:hidden">
                                    <div class="flex flex-col justify-center" style="background-color:transparent">
                                        <div class="name text-blue-600 text-sm">Create</div>
                                    </div>
                                    <div class="px-2 my-1 py-1 rounded text-gray-700 text-xs ml-2 bg-gray-200">
                                        <div class="font-bold">{{ typing }}</div>
                                    </div>
                                </div>
                            </div>
                        </transition>

                    </div>
                </template>

            </dropdown-tags>


        </div>


    </div>

</template>



<script>

import DropdownTags from '@/Jetstream/DropdownTags'

export default {

    props: ['thevideo', 'teamtags'],

    components: {
        DropdownTags
    },

    created: function () {
        //console.log("teamtags", this.teamtags)
        //this.$eventBus.$emit('viewed','');
        this.EventBus.on('refreshTags', (new_taglist) => {
            let needsRefresh = this.tags.length != new_taglist.length;
            this.tags = new_taglist;
            this.tags_filtered = new_taglist;
            //this.fetchTags();
            var video_tagList = [];
            for (const otag of this.video.tags) {
                for (const atag of this.tags) {
                    if (atag.id == otag.id) {
                        video_tagList.push(atag);
                        break;
                    }
                }
            }
            this.video.tags = video_tagList;
            if (needsRefresh) {
                this.refresh += 1;
            }


        });
    },

    beforeUnmount() {
        this.EventBus.off('refreshTags');
    },

    data() {
        return {
            video: this.thevideo,
            editing: false,
            newTop: 0,
            tags: this.teamtags,
            tags_filtered: this.teamtags,
            typing: '',
            slugFound: false,
            tagEditId: 0,
            tagEditName: '',
            tagEditColor: '',
            tagDeleteConfirm: 0,
            refresh: 0,
            offset: 0,
            colors: [
                { name: 'brown', color: '#e0cec6', darker: '#bea395' },
                { name: 'red', color: '#f4b6bb', darker: '#d1888e' },
                { name: 'orange', color: '#fadfbe', darker: '#d6b48a' },
                { name: 'yellow', color: '#fffec2', darker: '#dfde96' },
                { name: 'green', color: '#c9fccd', darker: '#96db9c' },
                { name: 'blue', color: '#c1e0fc', darker: '#95b7d6' },
                { name: 'purple', color: '#dbcaf0', darker: '#b8a3d3' },
                { name: 'grey', color: '#e4e4e4', darker: '#b9b9b7' },
            ]
        }
    },

    mounted: function () {
        // this.$refs.dropdown.$on('shown', () => {
        //   this.editing = true;
        //   this.$refs.newTag.focus();
        // });
        // this.$refs.dropdown.$on('hidden', () => {
        //   this.editing = false;
        //   this.typing = '';
        //   this.slugFound = false;
        //   this.tagEditId = 0;
        //   this.tagEditName = '';
        //   this.tagEditColor = '';
        //   this.tagDeleteConfirm = 0;
        //   this.tags_filtered = this.teamtags;
        // });

        /*this.$root.$on('bv::dropdown::show', bvEvent => {
          if (bvEvent.componentId == 'tag_video_'+this.video.id) {

          }
        });
        this.$root.$on('bv::dropdown::hide', bvEvent => {
          if (bvEvent.componentId == 'tag_video_'+this.video.id) {

          }
        });*/

    },

    methods:
    {
        onShow: function () {
            if (!this.$refs.dropdown.initialized) {
                return
            }
            this.editing = true;


            setTimeout(function () {
                this.$refs.newTag.focus();
            }.bind(this), 300)

        },
        onHide: function () {
            if (!this.$refs.dropdown.initialized) {
                return
            }
            this.editing = false;
            this.typing = '';
            this.slugFound = false;
            this.tagEditId = 0;
            this.tagEditName = '';
            this.tagEditColor = '';
            this.tagDeleteConfirm = 0;
            this.tags_filtered = this.teamtags;
        },
        getOffset: function () {
            let maxWidth = 423;
            let triggerWidth = this.$refs.tagBox.$el.clientWidth;
            if (triggerWidth > maxWidth) {
                let computed = ((maxWidth * 100) / triggerWidth) / 2;
                return String(computed) + '%';
            }
            return '0'
        },
        editTag: function (tag, event) {
            event.stopPropagation();
            this.typing = '';
            this.tagEditId = tag.id;
            this.tagEditName = tag.name;
            this.tagEditColor = tag.color;
            setTimeout(function () {
                let ref = 'input_tag_id_' + tag.id;
                document.getElementById(ref).focus();
            }.bind(this), 200);
        },

        blurInput: function (tag, event) {
            if (this.tagEditName == tag.name || tag.name.length == 0) {
                if (tag.name.length == 0) {
                    tag.name = this.tagEditName;
                }
                return;
            }
            let params = { name: tag.name };
            this.updateTag(tag, params);
        },

        cancelEdit: function (tag, event) {
            event.stopPropagation();
            this.tagEditId = 0;
        },

        attachTag: function (tag, event) {
            if (event != null) {
                event.stopPropagation();
            }
            for (const otag of this.video.tags) {
                if (otag.id == tag.id) {
                    return;
                }
            }
            let url = this.$page.props.api_url + '/v1/tag/' + tag.id + '/attach/' + this.video.id;
            var params = {};
            axios.post(url, params)
                .then(response => {
                    this.video.tags.push(tag);
                })
                .catch(e => {
                    console.error(e);
                });
        },

        detachTag: function (tag, event) {
            event.stopPropagation();
            let url = this.$page.props.api_url + '/v1/tag/' + tag.id + '/detach/' + this.video.id;
            var params = {};
            axios.post(url, params)
                .then(response => {
                    var tagList = [];
                    for (const otag of this.video.tags) {
                        if (otag.id != tag.id) {
                            tagList.push(otag);
                        }
                    }
                    this.video.tags = tagList;
                })
                .catch(e => {
                    console.error(e);
                });
        },

        changeColor: function (new_color, tag, event) {
            event.stopPropagation();
            if (new_color.color != tag.color) {
                let params = { color: new_color.color };
                tag.color = new_color.color;
                this.updateTag(tag, params);
            }
        },

        updateTag: function (tag, params) {
            let url = this.$page.props.api_url + '/v1/tag/' + tag.id;
            axios.post(url, params)
                .then(response => {
                    var tagList = [];
                    for (const otag of this.tags) {
                        if (otag.id != tag.id) {
                            tagList.push(otag);
                        } else {
                            tagList.push(tag);
                        }
                    }
                    this.tags = tagList;
                    this.EventBus.emit('refreshTags', this.tags);
                })
                .catch(e => {
                    if (e.response.status == 304) { // not changed
                        if (this.tagEditName != "") {
                            tag.name = this.tagEditName;
                        }
                        return;
                    }
                    console.error(e);
                });
        },

        filter: function () {
            if (this.typing.trim() != '') {
                this.tagEditId = 0;
                var filteredTags = [];
                let letters = this.typing.trim().toLowerCase().split('');
                let new_slug = this.str_slug(this.typing.trim());
                var slug_found = false;
                for (const tag of this.tags) {
                    var indexFound = -1;
                    var is_ok = true;
                    if (new_slug == tag.slug) {
                        slug_found = true;
                    }
                    var tagscan = tag.name.toLowerCase();
                    for (const letter of letters) {
                        let ind = tagscan.indexOf(letter);
                        if (ind >= 0) {
                            tagscan = tagscan.substring(ind);
                        } else {
                            is_ok = false;
                            break;
                        }
                    }
                    if (is_ok) {
                        filteredTags.push(tag);
                    }
                }
                this.tags_filtered = filteredTags;
                this.slugFound = slug_found;
            } else {
                this.tags_filtered = this.teamtags;
                this.slugFound = false;
            }
        },

        isFiltered: function (tag) {
            for (const otag of this.tags_filtered) {
                if (otag.id == tag.id) {
                    return true;
                }
            }
            return false;
        },

        enterNewTag: function () {
            if (this.typing.trim() != '' && !this.slugFound) {
                this.createTag(this.typing.trim())
            }
        },

        clickCreateTag: function (event) {
            event.stopPropagation();
            if (this.typing.trim() != '') {
                this.createTag(this.typing.trim())
            }
        },

        createTag: function (new_name) {
            let url = this.$page.props.api_url + '/v1/tag';
            let rand_color = this.colors[Math.floor(Math.random() * this.colors.length)];
            var params = { name: new_name, color: rand_color.color, video_id: this.video.id };
            axios.post(url, params)
                .then(response => {
                    let newTag = response.data;
                    this.tags.push(newTag);
                    this.video.tags.push(newTag);
                    this.EventBus.emit('refreshTags', this.tags);
                    this.typing = '';
                })
                .catch(e => {
                    console.error(e);
                });
        },

        deleteTag: function (tag, event) {
            event.stopPropagation();
            this.tagDeleteConfirm = tag.id;
        },

        cancelDelete: function (tag, event) {
            this.tagDeleteConfirm = 0;
        },

        confirmDelete: function (tag, event) {
            let url = this.$page.props.api_url + '/v1/tag/' + tag.id + '/delete';
            var params = {};
            axios.post(url, params)
                .then(response => {
                    var tagList = [];
                    for (const otag of this.tags) {
                        if (otag.id != tag.id) {
                            tagList.push(otag);
                        }
                    }
                    this.tags = tagList;
                    this.EventBus.emit('refreshTags', this.tags);
                })
                .catch(e => {
                    console.error(e);
                });
        },

        clickTagBox: function (event) {
            if (this.editing) {
                event.stopPropagation();
            }
        },



        styleColor: function (color, tag) {
            var border = color.darker;
            if (tag.color == color.color) {
                border = '#686868';
            }
            return 'border-color:' + border + '; background-color:' + color.color + ';';
        },

        // kudos: https://www.davidvandertuijn.nl/laravel-strslug-javascript-equivalent
        str_slug: function (title, separator) {
            if (typeof separator == 'undefined') separator = '-';

            // Convert all dashes/underscores into separator
            var flip = separator == '-' ? '_' : '-';
            title = title.replace(flip, separator);

            // Remove all characters that are not the separator, letters, numbers, or whitespace.
            title = title.toLowerCase()
                .replace(new RegExp('[^a-z0-9' + separator + '\\s]', 'g'), '');

            // Replace all separator characters and whitespace by a single separator
            title = title.replace(new RegExp('[' + separator + '\\s]+', 'g'), separator);

            return title.replace(new RegExp('^[' + separator + '\\s]+|[' + separator + '\\s]+$', 'g'), '');
        }



    },

    computed: {
        /*containerClass: function() {
          return 'tag_container';
        },
        computedTop: function () {
          return this.newTop + 'px';
        }*/
        filtered_tags: function () {
            var new_array = []
            for (const t of this.tags) {
                if (this.isFiltered(t)) {
                    new_array.push(t)
                }
            }
            return new_array
        }

    },

}

</script>

<style scoped>
.tagsContainer.empty .addtag {
    /* position: absolute;
    left: 4px;
    top: 5px; */
    display: none;
}

.tagsContainer.empty:hover .addtag {
    display: block;
}

.tagsContainer.empty .notag {
    /* position: absolute;
    left: 0;
    top: 5px; */
    display: block;
}

.tagsContainer.empty:hover .notag {
    display: none;
}





input.newTag {
    border: 0;
    border-bottom: 1px solid #DDD;
    border-radius: 0;
    font-size: 0.9rem;
    padding-left: 15px;
}

input.editTag {
    border: 0;
    border-bottom: 1px solid #DDD;
    border-radius: 0;
    font-size: 0.8rem;
    background: none;
    padding: 0 5px 0 5px;
    margin-left: 11px;
    margin-right: 11px;
    width: 90%;
}

.form-control:-moz-focusring,
.StripeElement:-moz-focusring {
    text-shadow: none;
}




ul.tag_colorpicker li {
    display: flex;
    height: 24px;
    border: 1px solid #ababab;
    border-radius: 4px;
    flex-grow: 1;
    margin: 0 4px;
    cursor: pointer;
    max-width: 24px;
}

ul.tag_colorpicker li:hover {
    opacity: 0.8;
}







.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: all 0.2s ease-out;
}

.fade-leave-to {
    opacity: 0;
}

.fade-leave-active {
    transition: all 0.2s ease-in;
}
</style>
